export const HOME_URL = '/';
export const ABOUT_URL = '/about';

export const LOGIN_URL = '/login';

export const USER_SETTINGS_URL = '/user/settings';

export const TRANSACTIONS_URL = '/transactions';

export const ADMINISTRATION_PAGE_URL = '/administration';

export const PERIODIC_REPORT = '/reports/periodic-report';

export const Z_REPORTS = '/reports/z-reports';

export const SALES_OVERVIEW_REPORT = '/reports/sales/overview';

export const TOP_SALES_PER_CATEGORY_REPORT = '/reports/top-sales/per-category';
export const TOP_SALES_PER_PRODUCT_REPORT = '/reports/top-sales/per-product';

export const SETTINGS_MACHINES = '/settings/machines';
export const SETTINGS_INVOICES = '/settings/invoices';
export const SETTINGS_BACKUP = '/settings/backup'; // TODO page component

export const STANDARD_REPORT_URL = '/reports/standard';
export const SIE4_REPORT_URL = '/reports/sie4';

export const SETTINGS_INTEGRATIONS = '/settings/integrations';

export const COMPARISON_REPORT_URL = '/reports/standard/comparison';

export const KNOWLEDGE_PORTAL_URL = 'https://eskassa.se/kunskapsportalen/';

export const SWEDISH_IRS = 'https://eskassa.se/skv';

export const FRESHDESK_URL = '/freshdesk';

export const PARSLY_URL = 'https://app.parsly.com/login';

export const ESORDER_URL = 'https://app.esorder.se/backoffice';

export const UPGRADE_PAGE = '/upgrade';

export const CONTACT_SALES = '/contact';
